var map = {
	"./aprobar-planificacion/aprobar-planificacion.module": [
		"./src/app/paginas/aprobar-planificacion/aprobar-planificacion.module.ts",
		"common",
		"aprobar-planificacion-aprobar-planificacion-module"
	],
	"./configuracion/configuracion.module": [
		"./src/app/paginas/configuracion/configuracion.module.ts"
	],
	"./modulo02/modulo02.module": [
		"./src/app/paginas/modulo02/modulo02.module.ts",
		"modulo02-modulo02-module"
	],
	"./planificacion/planificacion.module": [
		"./src/app/paginas/planificacion/planificacion.module.ts"
	],
	"./produccion/produccion.module": [
		"./src/app/paginas/produccion/produccion.module.ts",
		"produccion-produccion-module"
	],
	"./servicio-catering/servicio-catering.module": [
		"./src/app/paginas/servicio-catering/servicio-catering.module.ts",
		"common",
		"servicio-catering-servicio-catering-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;